import { render, staticRenderFns } from "./PlayerHistory.vue?vue&type=template&id=6350d354&scoped=true&"
import script from "./PlayerHistory.vue?vue&type=script&lang=js&"
export * from "./PlayerHistory.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHistory.vue?vue&type=style&index=0&id=6350d354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350d354",
  null
  
)

export default component.exports